import { put, call } from 'redux-saga/effects';
import { createNewPayment as createNewPaymentRepo } from '../../repositories/PaymentsRepository';
import { UnauthorizedErrorName } from '../../constants/errorName';
import { HandleUnauthorizedErrorAndLogout } from '../../helpers/AuthorizeHelper';
import { routerPaths } from '../../constants/routerPaths';
import { ApiConstants, OverlaysConstants } from '../../constants/actions';
import { replacePage } from '../../actions/navigation';

export default function* createNewPayment(payload) {
  try {
    const createNewPaymentResponse = yield call(createNewPaymentRepo, payload);

    yield put({
      type: `${ApiConstants.CREATE_NEW_PAYMENT}_SUCCESS`,
      payload: createNewPaymentResponse
    });
    yield put(
      replacePage(
        `${routerPaths.maksuturvaPayment}?paymentId=${payload.payload.paymentPublicId}`
      )
    );
  } catch (ex) {
    // change the loading status
    yield put({
      type: `${ApiConstants.CREATE_NEW_PAYMENT}_FAILURE`,
      payload: ex
    });
    if (ex.name === UnauthorizedErrorName) {
      yield call(HandleUnauthorizedErrorAndLogout);
    } else {
      // display the error message
      yield put({
        type: `${OverlaysConstants.SHOW_ERROR_POPUP}`,
        closable: false
      });
    }
  }
}
